import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { dateFormat } from '../../../SPRINTA/helpers/Formatter'
import style from './style.css'
import Additionals from '../Add'
export default class Voucher extends Component {

    render() {
        const { token, title, confirmationDate, participants, extras } = this.props
        return (
            <div>
                <div className={style.voucher} style={{ border: '1px solid' }}>
                    <div ref='voucher' style={{ float: 'left', padding: '50px' }}>
                        <span className={style.title}><b>Voucher</b></span>

                        <div style={{ float: 'left', width: '100%', backgroundColor: '#f9f9f9', padding: '30px' }}>
                            <div className={style.qr} style={{ backgroundColor: '#fff', padding: '20px' }}>
                                <QRCode value={token} size={200} />
                                <span className={style.token}>{token}</span>
                            </div>

                            <br/>
                            
                            <div style={{fontSize: '18px', textAlign: 'center', width: '100%', size: '30px', fontWeight: 'bold', marginBottom: '30px'}}>
                                {title}
                            </div>

                            {confirmationDate && (
                                <div className={style.data}>
                                    Data da confirmação/Confirmation date
                                    <br/>
                                    <b>{dateFormat('d/m/y', confirmationDate)}</b>
                                </div>
                            )}

                            {participants && (
                                <div className={style.boxList}>
                                    <h3>Atletas/Athletes</h3>
                                    <ul>
                                        {participants.map(item => (
                                            <li key={item.athlete_name}>
                                                {item.athlete_name} <br/>
                                                <small>
                                                    {item.document && item.document !== "" && <span>Documento/Document: {item.document}</span> }
                                                    {item.document && item.document !== "" && item.category && item.category !== "" && <span> | </span> }
                                                    {item.category && item.category !== "" && <span>{item.category}</span> } <br/>
                                                    {item.name && item.name !== '' && <span>{item.name}</span>}
                                                    {item.name && item.lote_name && <span> - </span>}
                                                    {item.lote_name && item.lote_name !== '' && <span>{item.lote_name}</span>}<br/>
                                                    {item.addc && item.addc !== '' && (
                                                        <span>
                                                            <Additionals additionals={item.addc} />
                                                        </span>
                                                    )}
                                                </small>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {extras && (
                                <div className={style.boxList}>
                                    <h3>Itens extras/Extras sales</h3>
                                    <ul>
                                        {extras.map(item => (
                                            <li key={item.product.id_extra}>
                                                {item.product.qtdy}x {item.product.description}
                                                {item.product.label && item.product.label !== '' && (
                                                    <span>| {item.product.options_name}: {item.product.label}</span>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/App/Components/Voucher/index.js